import {
  GET_STORED_LANGUAGE_REQUEST,
  GET_STORED_LANGUAGE_SUCCESS,
  GET_STORED_LANGUAGE_FAILURE,

  SET_STORED_LANGUAGE_REQUEST,
  SET_STORED_LANGUAGE_SUCCESS,
  SET_STORED_LANGUAGE_FAILURE
} from '../../constants/actions';

import config from '../../constants/config.js';

const languageItemName = '__LANGUAGE_ISO-639-1__' + config.DOMAIN + '__' + config.ENVIRONMENT + '__';

function getStoredLanguageRequest () {
  return {
    type: GET_STORED_LANGUAGE_REQUEST
  };
}
function getStoredLanguageSuccess (language) {
  return {
    type: GET_STORED_LANGUAGE_SUCCESS,
    code: language
  };
}
function getStoredLanguageError (error) {
  return {
    type: GET_STORED_LANGUAGE_FAILURE,
    code: '',
    error: error.cause || error
  };
}

function setStoredLanguageRequest () {
  return {
    type: SET_STORED_LANGUAGE_REQUEST
  };
}
function setStoredLanguageSuccess (language) {
  return {
    type: SET_STORED_LANGUAGE_SUCCESS,
    code: language
  };
}
function setStoredLanguageError (error) {
  return {
    type: SET_STORED_LANGUAGE_FAILURE,
    code: '',
    error: error.cause || error
  };
}

export function getStoredLanguage () {
  return dispatch => {
    dispatch(getStoredLanguageRequest());
    try {
      var language = localStorage.getItem(languageItemName);
      dispatch(getStoredLanguageSuccess(language));
    } catch (error) {
      dispatch(getStoredLanguageError(error));
    }
  };
}
export function setStoredLanguage (language) {
  return dispatch => {
    dispatch(setStoredLanguageRequest());
    try {
      localStorage.setItem(languageItemName, language);
      dispatch(setStoredLanguageSuccess(language));
    } catch (error) {
      dispatch(setStoredLanguageError(error));
    }
  };
}
